var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.549 48.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3542"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 525",
    d: "M39.459 39.261l2.617 2.357-5.579.982-1.626.289.106-1.193.528-6 2.693 2.434a4.12 4.12 0 00.261-.375v-.01a19.9 19.9 0 003.406-11.169A20.092 20.092 0 0021.777 6.483 20.09 20.09 0 001.683 26.57a20.09 20.09 0 0020.088 20.093 20.1 20.1 0 0011.2-3.406l1.308 1.145a21.764 21.764 0 01-30.32-5.3 21.764 21.764 0 011.583-27.017l-2.713-3.1 2.877-2.511 2.607 3a21.507 21.507 0 0111.419-4.579V3.808h-3.915V-.001h12.392v3.809h-4.176v1.1a21.628 21.628 0 0110.592 4.089l2.088-2.492 3.3 2.761-2.185 2.607a21.739 21.739 0 011.914 26.995c-.088.13-.185.259-.283.393z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3541"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1241",
    d: "M16.973 40.161l-1.965-.002.024-24.247 1.965.002z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3162",
    d: "M30.7 25.113c-3.9-2.2-7.807 2.2-11.71-.009l.011-8.477c3.9 2.2 7.807-2.2 11.711.009z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.686fcc7f.svg";
export { ForwardRef as ReactComponent };